import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-info-circle',
  imports: [],
  templateUrl: './info-circle.html',
  styleUrl: './info-circle.scss',
})
export class InfoCircle {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
